import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Search from './Search';
import Signup from './components/Auth/Signup';
import Login from './components/Auth/Login';
import ForgotPassword from './components/Auth/ForgotPassword';
import Postavke from './components/Postavke';
import AdminPanel from './components/AdminPanel';
import About from './About';
import HowToUse from './HowToUse';
import Privacy from './Privacy';
import AnalyticsTracker from './components/AnalyticsTracker';
import NewsNotificationDelivery from './components/NewsNotificationDelivery';
import NotificationFeed from './components/NotificationFeed';
import DeleteAccountPage from './components/DeleteAccountPage';
import NativeNavigation from './components/NativeNavigation';
import NativeHome from './components/NativeHome';
import VerificationLogin from './components/Auth/VerificationLogin';
import './SearchLayout.css';
import './ApplicationLayout.css';

function App() {
  return (
    <div className="App">
      <Router>
        <NativeNavigation />
        <AnalyticsTracker />
        <NewsNotificationDelivery />
        {window.jaosveNative && <NativeHome />}
        <Routes>
          <Route path="/" element={window.jaosveNative ? null : <Search />} />
          <Route path="/notifications/:subscriptionId/:batchToken" element={<NotificationFeed />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/verified" element={<VerificationLogin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/postavke" element={<Postavke />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/how-to-use" element={<HowToUse />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
